import React from 'react'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Box} from '@mui/material';
import {PageTitle, WideWhiteArea} from '../common/resident/NatResidentApplicationsCommon'
import {NatResidentStepper} from '../../common/resident/NatResidentStepper'
import {BreakPcOnly} from '../../../../styledComponents/DisplayItem'
import {Location} from 'react-router-dom'


interface Props {
    location: Location
}

const NatResidentUserRegistrationMailSendCompletePage
    : React.FC<Props & ResidentWithErrorHandlingPagePropsSet> = props => {
    return (<>
        <BlockSpacer height={'30px'}/>
        <NatResidentStepper
            stepList={[
                {label: '手続き説明'},
                {label: <>マンション・<BreakPcOnly/>メールアドレス登録</>},
                {label: 'メール受信', isActive: true},
                {label: '申請者情報登録'},
                {label: '申請者情報確認'},
                {label: '申請提出完了', isSquare: true}
            ]}
        />
        <BlockSpacer height={'30px'}/>
        <PageTitle>
            メール受信
        </PageTitle>
        <Box height={'20px'}/>
        <WideWhiteArea>
            <Box height={'15px'}/>
            ご登録いただいたメールアドレスに確認メールを送信しました。<br/>
            届いたメールに添付されたURLより素敵ネットユーザ登録申請を行ってください。<br/>
            yahooメールなどをご利用の方で、メール受信フォルダにメールが見当たらない方は、迷惑メールフォルダをご確認ください。
            <Box height={'20px'}/>
        </WideWhiteArea>
    </>)
}

export default createResidentWithErrorHandlingPage(NatResidentUserRegistrationMailSendCompletePage)
